// @ts-nocheck
/* ============================================================
   FAVORITES – localStorage saved items
   CleanSecret theme custom feature
   ============================================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'cs_favorites';

  /* ── Storage helpers ──────────────────────────────────────── */

  function getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (_) {
      return [];
    }
  }

  function saveFavorites(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (_) {}
  }

  function isFavorite(id) {
    return getFavorites().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function addFavorite(product) {
    var list = getFavorites();
    if (!isFavorite(product.id)) {
      list.push(product);
      saveFavorites(list);
    }
  }

  function removeFavorite(id) {
    saveFavorites(
      getFavorites().filter(function (item) {
        return String(item.id) !== String(id);
      })
    );
  }

  function toggleFavorite(product) {
    if (isFavorite(product.id)) {
      removeFavorite(product.id);
      return false;
    }
    addFavorite(product);
    return true;
  }

  /* ── UI updaters ──────────────────────────────────────────── */

  function updateFavoriteButtons() {
    document.querySelectorAll('.favorite-btn').forEach(function (btn) {
      var saved = isFavorite(btn.dataset.productId);
      btn.classList.toggle('favorite-btn--saved', saved);
      var icon = btn.querySelector('.favorite-btn__icon');
      var text = btn.querySelector('.favorite-btn__text');
      if (text) text.textContent = saved ? 'I\u0161saugota' : 'Prid\u0117ti \u012f m\u0117gstamiausias';
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function updateFavoriteCount() {
    var count = getFavorites().length;
    document.querySelectorAll('.favorites-count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  /* ── Button events ────────────────────────────────────────── */

  function handleFavoriteClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = this;
    var product = {
      id: btn.dataset.productId,
      title: btn.dataset.productTitle,
      handle: btn.dataset.productHandle,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice,
      url: btn.dataset.productUrl,
    };
    toggleFavorite(product);
    updateFavoriteButtons();
    updateFavoriteCount();
  }

  function attachFavoriteButtons() {
    document.querySelectorAll('.favorite-btn').forEach(function (btn) {
      btn.removeEventListener('click', handleFavoriteClick);
      btn.addEventListener('click', handleFavoriteClick);
    });
    updateFavoriteButtons();
  }

  /* ── Favorites page rendering ─────────────────────────────── */

  function renderFavoritesPage() {
    var container = document.getElementById('favorites-grid');
    if (!container) return;

    var favorites = getFavorites();
    var emptyState = document.getElementById('favorites-empty');

    if (favorites.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.style.display = 'block';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';

    container.innerHTML = favorites
      .map(function (product) {
        var imgHtml = product.image
          ? '<img src="' + escAttr(product.image) + '" alt="' + escAttr(product.title) + '" class="fav-card__image" loading="lazy" />'
          : '<span class="fav-card__image--placeholder" aria-hidden="true">\uD83D\uDDBB</span>';

        return (
          '<div class="fav-card" data-product-id="' + escAttr(product.id) + '">' +
            '<a href="' + escAttr(product.url) + '" class="fav-card__image-link">' +
              imgHtml +
            '</a>' +
            '<div class="fav-card__body">' +
              '<a href="' + escAttr(product.url) + '" class="fav-card__title">' + escHtml(product.title) + '</a>' +
              '<p class="fav-card__price">' + escHtml(product.price) + '</p>' +
              '<div class="fav-card__actions">' +
                '<button class="fav-card__add-btn" data-product-handle="' + escAttr(product.handle) + '" type="button">\u012edeti \u012f krep\u0161el\u012f</button>' +
                '<button class="fav-card__remove-btn" data-product-id="' + escAttr(String(product.id)) + '" type="button">\u2715 Pa\u0161alinti</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      })
      .join('');

    container.querySelectorAll('.fav-card__remove-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFavorite(this.dataset.productId);
        renderFavoritesPage();
        updateFavoriteCount();
      });
    });

    container.querySelectorAll('.fav-card__add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCartByHandle(this.dataset.productHandle, this);
      });
    });
  }

  /* ── Add to cart via AJAX ─────────────────────────────────── */

  function addToCartByHandle(handle, btn) {
    btn.disabled = true;
    btn.textContent = 'Dedama\u2026';

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Product fetch failed');
        return r.json();
      })
      .then(function (productData) {
        var availableVariant = productData.variants.find(function (v) {
          return v.available;
        }) || productData.variants[0];

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: availableVariant.id, quantity: 1 }),
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = '\u2713 Prid\u0117ta!';
        btn.classList.add('fav-card__add-btn--added');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          btn.textContent = '\u012edeti \u012f krep\u0161el\u012f';
          btn.disabled = false;
          btn.classList.remove('fav-card__add-btn--added');
        }, 2200);
      })
      .catch(function () {
        btn.textContent = 'Klaida \u2013 bandykite dar kart\u0105';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = '\u012edeti \u012f krep\u0161el\u012f';
        }, 2800);
      });
  }

  /* ── Helpers ──────────────────────────────────────────────── */

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(str) {
    return String(str || '').replace(/"/g, '&quot;');
  }

  /* ── Init ─────────────────────────────────────────────────── */

  function init() {
    attachFavoriteButtons();
    updateFavoriteCount();
    renderFavoritesPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  /* Expose for external use if needed */
  window.CleanSecretFavorites = {
    getFavorites: getFavorites,
    addFavorite: addFavorite,
    removeFavorite: removeFavorite,
    isFavorite: isFavorite,
  };
})();
